import { obtenerSiteConfigGuardada } from './siteConfig';

const moneda = '$';
export const monedasTienda = ['$', 'US$', '€'];

export function getProductMoneda() {
    const storeMoneda = String(obtenerSiteConfigGuardada()?.moneda || '').trim();

    return monedasTienda.includes(storeMoneda) ? storeMoneda : moneda;
}

export default moneda;
